function isValidGermanPlz(value) {
  return /^(?!00)\d{5}$/.test(value);
}

function bindPlzValidation(inputId) {
  const input = document.getElementById(inputId);
  if (!input) return;
  const errorMsg = 'Bitte geben Sie eine gültige deutsche Postleitzahl (PLZ) ein.';
  const update = () => input.setCustomValidity(isValidGermanPlz(input.value) ? '' : errorMsg);
  input.addEventListener('input', update);
  input.addEventListener('change', update);
}

$(document).on('turbo:load', function () {
  var label_text = "Anhang hinzufügen";

  // ==== PLZ custom validity ====
  bindPlzValidation('plz');
  bindPlzValidation('error_address_zip');

  // ==== File input handlers ====
  $('#attachment-1').on("change", function () {
    setFileInput("attachment-1");
  });
  $('#attachment-2').on("change", function () {
    setFileInput("attachment-2");
  });
  $('#attachment-3').on("change", function () {
    setFileInput("attachment-3");
  });

  $('.deleteFile').on("click", function () {
    resetFileInput($(this).data("name"));
  });

  $('#addInput').on("click", function () {
    if ($("#attachment-2").parents().hasClass("d-none")) {
      $("#attachment-2").parents().removeClass("d-none");
    } else {
      $("#attachment-3").parents().removeClass("d-none");
      $(this).addClass("d-none");
    }
  });

  $('.remove_input').on("click", function () {
    $(this).parent(".row").addClass("d-none");
    $('#addInput').removeClass("d-none");
  });

  function setFileInput(attachment) {
    var file = $(`#${attachment}`)[0].files[0];
    if (!file) return;
    var file_name = file.name;
    $(`#${attachment}`).parent().siblings(".deleteFile").removeClass('d-none');
    $(`#${attachment}`).parent().siblings(".cam-btn").addClass('d-none');
    $(`#${attachment}`).parent().siblings(".remove_input").addClass('d-none');
    $(`#${attachment}`).siblings().children(".file_label").text(file_name);
  }

  function resetFileInput(attachment) {
    $(`#${attachment}`).siblings().children(".file_label").text(label_text);
    $(`#${attachment}`).parent().siblings(".cam-btn").removeClass('d-none');
    $(`#${attachment}`).parent().siblings(".deleteFile").addClass('d-none');
    $(`#${attachment}`).parent().siblings(".remove_input").removeClass('d-none');
    $(`#${attachment}`).val('');
  }

  function resetAllFileInputs() {
    var fileInputs = ["attachment-1", "attachment-2", "attachment-3"];
    $(fileInputs).each((index, element) => {
      resetFileInput(element);
    });
  }

  // ==== Form submit / validation ====
  (function () {
    'use strict';
    var forms = document.querySelectorAll('.needs-validation');

    // small helper to support both Bootstrap 5 (native) and legacy jQuery plugin
    const showModal = (id) => {
      const el = document.getElementById(id);
      if (!el) return;
      if (window.bootstrap && bootstrap.Modal) {
        new bootstrap.Modal(el).show();
      } else if (window.$ && $(el).modal) {
        $(el).modal('show');
      } else {
        // very last-resort fallback (non-animated)
        el.classList.add('show');
        el.style.display = 'block';
        el.removeAttribute('aria-hidden');
      }
    };

    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        const headerHeight = $("nav").height() + 20;

        const invalidFormCheckInputs = form.querySelectorAll('.form-check-input:invalid');
        const invalidFormControls = form.querySelectorAll('.form-control:invalid');

        if (!form.checkValidity() || invalidFormCheckInputs.length > 0 || invalidFormControls.length > 0) {
          event.stopPropagation();

          const firstInvalidElement = invalidFormCheckInputs.length > 0 ? invalidFormCheckInputs[0] : invalidFormControls[0];
          if (firstInvalidElement) {
            const rect = firstInvalidElement.getBoundingClientRect();
            const scrollPosition = window.scrollY || window.pageYOffset;

            window.scrollTo({
              top: rect.top + scrollPosition - headerHeight,
              behavior: 'smooth'
            });
          }
        }

        form.classList.add('was-validated');

        if (form.checkValidity() !== true) return;

        const $submitBtn = $(form).find('button[type="submit"]');
        const btn_text = $submitBtn.html();
        $submitBtn.html('<span class="spinner-border fs-xs text-white"></span>');

        try {
          // IMPORTANT: only serialize inputs from this form
          const data = $(form).find(':input').serializeArray();
          const payload = data.reduce(function (obj, o) {
            obj[o.name] = o.value;
            return obj;
          }, {});

          if (payload.contactType === 'ort_unavailable') {
            const placeText = (payload.placeName || '').trim();
            const plzText = (payload.plz || '').trim();
            const demandParts = [];
            if (placeText) demandParts.push(placeText);
            if (plzText) demandParts.push(`PLZ ${plzText}`);
            if (demandParts.length) payload.demand_for_ort = demandParts.join(' - ');
          }

          const resp = await postContactForm(payload, form.name);
          const isSuccess = resp && (resp.status === 'success' || resp.success === true);

          if (isSuccess) {
            if (form.name === 'push_email_sub') {
              if (resp.token) {
                window.localStorage.setItem('email-sub-token', resp.token);
              }
              $("#alert-title").text("Daaaaanke!");
              $("#alert-details").text("Eine E-Mail ist bereits auf dem Weg in Dein Postfach. Das kann einige Minuten dauern. Falls Du nichts bekommst, checke auch Dein Spam-Postfach.");
              showModal('alert-modal');
            } else {
              showModal('formSubmissionModal');
              resetAllFileInputs();
            }
          } else {
            // non-success path
            if (form.name === 'push_email_sub') {
              $("#alert-title").text("Abonnement-Fehler");
              $("#alert-details").text("Diese E-Mail-Adresse wurde bereits registriert. Verwende entweder das Gerät, mit dem Du dich registriert hast oder schau in der Hilfe nach.");
              showModal('alert-modal');
            } else {
              $("#alert-title").text("Fehler");
              $("#alert-details").text("Deine Nachricht konnte nicht gesendet werden. Bitte versuche es später erneut.");
              showModal('alert-modal');
            }
          }
        } catch (e) {
          // Network / parse / unexpected error
          $("#alert-title").text("Technischer Fehler");
          $("#alert-details").text("Es ist ein unerwarteter Fehler aufgetreten. Bitte versuche es später erneut.");
          showModal('alert-modal');
          // console.error(e);
        } finally {
          resetAllFileInputs();
          form.classList.remove('was-validated');
          form.reset();
          $submitBtn.html(btn_text);
        }
      }, false);
    });
  })();

  // ==== Dynamic placeholders / field visibility ====
  const $plz = $('#plz');
  const $place = $('#placeName');
  const $attachments = $('#attachments');
  const $referenceField = $('#reference');

  if ($plz.length && $place.length) {
    const unavailablePlzPlaceholder = "Wie lautet die PLZ Deines Wunschortes";
    const unavailablePlacePlaceholder = "Wie heißt Dein Wunschort in der App?";

    const defaultPlzPlaceholder = "PLZ";
    const defaultPlacePlaceholder = "Ort";

    const setLocationFields = ({ placeholderPlz, placeholderPlace }) => {
      $plz.removeClass('d-none')
        .attr('placeholder', placeholderPlz)
        .attr('required', 'required');
      $place.removeClass('d-none')
        .attr('placeholder', placeholderPlace)
        .attr('required', 'required');
    };

    const setDefaultLocationState = () => setLocationFields({
      placeholderPlz: defaultPlzPlaceholder,
      placeholderPlace: defaultPlacePlaceholder
    });

    const setUnavailableLocationState = () => setLocationFields({
      placeholderPlz: unavailablePlzPlaceholder,
      placeholderPlace: unavailablePlacePlaceholder
    });

    setDefaultLocationState();

    // guard contactType change
    $('input[name="contactType"]').off('change.plzGuard').on('change.plzGuard', function () {
      const unavailableSelected = $('input[name="contactType"]:checked').val() === 'ort_unavailable';

      if (unavailableSelected) {
        $attachments.addClass("d-none");
        setUnavailableLocationState();
      } else {
        $attachments.removeClass("d-none");
        setDefaultLocationState();
      }

      const othersOptionSelected = $('input[name="contactType"]:checked').val() === 'other';

      if (!othersOptionSelected) {
        $referenceField.addClass('d-none').removeAttr('required');
      } else {
        $referenceField.removeClass('d-none').attr('required', 'required');
      }
    });

    // Trigger once at load so placeholders match current state
    $('input[name="contactType"]:checked').trigger('change');

    // ==== Preselect + lock options when arriving from "Wunschort unavailable" link ====
    if (new URLSearchParams(window.location.search).has('ort_unavailable')) {
      $('input[name="contactType"]').not('#ort_unavailable').closest('.form-check').hide();
      $('input[name="contactType"]').not('#ort_unavailable').prop('disabled', true);
    }
  }
});

// ==== API + helpers (unchanged except for small safety tweaks) ====
async function postContactForm(payload, form_name) {
  let formData = new FormData();
  var browserInfo = getBrowserInfo();
  var osInfo = getOSInfo();
  let device_info = `model :  ${browserInfo.name + ' ' + browserInfo.version} ,  OS_version :  ${osInfo.name + ' ' + osInfo.version}`;
  payload.device_info = device_info;

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  var fileOne   = $('form :input#attachment-1[type="file"]').length > 0 && $('form :input#attachment-1[type="file"]')[0].files[0];
  var fileTwo   = $('form :input#attachment-2[type="file"]').length > 0 && $('form :input#attachment-2[type="file"]')[0].files[0];
  var fileThree = $('form :input#attachment-3[type="file"]').length > 0 && $('form :input#attachment-3[type="file"]')[0].files[0];

  let photos = [];
  fileOne && await getBase64(fileOne).then(
    data => photos.push({ index: 1, fileName: fileOne.name, fileBlob: data })
  );
  fileTwo && await getBase64(fileTwo).then(
    data => photos.push({ index: 2, fileName: fileTwo.name, fileBlob: data })
  );
  fileThree && await getBase64(fileThree).then(
    data => photos.push({ index: 3, fileName: fileThree.name, fileBlob: data })
  );
  formData.append('photos', JSON.stringify(photos));

  formData.append('device_info', JSON.stringify(device_info));

  let url_ = '';
  if (form_name === "contact_form") {
    url_ = '/submit-contact-form.json';
    formData.append('contactForm', JSON.stringify(payload));
  }
  if (form_name === "error_report") {
    url_ = '/submit-error-form.json';
    formData.append('contactForm', JSON.stringify(payload));
  }
  if (form_name === "push_email_sub") {
    url_ = '/email-subscription';
    let types_array_ = localStorage.getItem('notification_types');
    formData.append('pushEmail', JSON.stringify(payload));
    formData.append('push_kinds', types_array_);
  }
  if (form_name === "violation_report") {
    url_ = '/submit-violation-form';
    formData.append('contactForm', JSON.stringify(payload));
  }

  const response = await fetch(`${url_}`, {
    method: 'post',
    headers: {
      "X-CSRF-Token": document.querySelectorAll('meta[name="csrf-token"]')[0]["content"],
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: formData
  });

  let parsedBody = {};
  try {
    parsedBody = await response.json();
  } catch (e) {
    parsedBody = {};
  }

  // normalize failures to a predictable object
  if (!response.ok) {
    return { status: 'error', code: response.status, data: parsedBody };
  }

  // normalize success: some endpoints return {success: true} instead of status
  if (parsedBody && (parsedBody.status || parsedBody.success !== undefined)) {
    return parsedBody;
  }

  // fall back to treating HTTP 2xx as success even without an explicit status flag
  return { status: 'success', ...parsedBody };
}

function getBrowserInfo() {
  var ua = navigator.userAgent;
  var tem;
  var matchedBrowser = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

  if (/trident/i.test(matchedBrowser[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: 'IE', version: (tem[1] || '') };
  }

  if (matchedBrowser[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) {
      return { name: tem[1].replace('OPR', 'Opera'), version: tem[2] };
    }
  }

  matchedBrowser = matchedBrowser[2] ? [matchedBrowser[1], matchedBrowser[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    matchedBrowser.splice(1, 1, tem[1]);
  }

  return {
    name: matchedBrowser[0],
    version: matchedBrowser[1]
  };
}

function getOSInfo() {
  var userAgent = navigator.userAgent;
  var name = 'Unknown';
  var version = 'Unknown';

  if (userAgent.indexOf('Win') !== -1) {
    name = 'Windows';
    if (userAgent.indexOf('Windows NT 10.0') !== -1) {
      version = '10';
    } else if (userAgent.indexOf('Windows NT 6.3') !== -1) {
      version = '8.1';
    } else if (userAgent.indexOf('Windows NT 6.2') !== -1) {
      version = '8';
    } else if (userAgent.indexOf('Windows NT 6.1') !== -1) {
      version = '7';
    } else if (userAgent.indexOf('Windows NT 6.0') !== -1) {
      version = 'Vista';
    } else if (userAgent.indexOf('Windows NT 5.1') !== -1) {
      version = 'XP';
    } else if (userAgent.indexOf('Windows NT 5.0') !== -1) {
      version = '2000';
    }
  } else if (userAgent.indexOf('Mac') !== -1) {
    name = 'MacOS';
    if (userAgent.indexOf('Mac OS X 10_15') !== -1) {
      version = 'Catalina';
    } else if (userAgent.indexOf('Mac OS X 10_14') !== -1) {
      version = 'Mojave';
    } else if (userAgent.indexOf('Mac OS X 10_13') !== -1) {
      version = 'High Sierra';
    } else if (userAgent.indexOf('Mac OS X 10_12') !== -1) {
      version = 'Sierra';
    } else if (userAgent.indexOf('Mac OS X 10_11') !== -1) {
      version = 'El Capitan';
    } else if (userAgent.indexOf('Mac OS X 10_10') !== -1) {
      version = 'Yosemite';
    }
  } else if (userAgent.indexOf('Linux') !== -1) {
    name = 'Linux';
  } else if (userAgent.indexOf('Android') !== -1) {
    name = 'Android';
    if (userAgent.indexOf('Android 10') !== -1) {
      version = '10';
    } else if (userAgent.indexOf('Android 9') !== -1) {
      version = '9';
    } else if (userAgent.indexOf('Android 8') !== -1) {
      version = '8';
    }
  } else if (userAgent.indexOf('iOS') !== -1) {
    name = 'iOS';
    var match = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
    if (match !== null && match.length >= 3) {
      version = match[1] + '.' + match[2] + '.' + (match[3] | 0);
    }
  }

  return {
    name: name,
    version: version
  };
}
